import moment from "moment";
import settings from "../utils/settings";

const useAllStat = () => {
  const _fetch = async ({
    fromDate,
    toDate,
    periodType,
    type,
    isVoid = false,
    filter = null,
    allBranch = false,
  }) => {
    let { branchId, token } = settings();
    if (allBranch) branchId = null;
    let urlBranch = "";
    if (branchId) urlBranch = `&branch_id=${branchId}`;
    const beginning = moment().subtract(10, "years").format("YYYY-MM-DD");
    const end = moment().format("YYYY-MM-DD");
    let url = `${process.env.REACT_APP_API_ENDPOINT}/stat/${type}?period_type=${periodType}&from=${fromDate}&to=${toDate}${urlBranch}`;
    if (type === "transactions") {
      url = `${process.env.REACT_APP_API_ENDPOINT}/transactions?from=${beginning}&to=${end}${urlBranch}`;
    }

    if (isVoid && fromDate === toDate) {
      url += `&addon={"void_remark":1,"void_by_id":1,"create_local_time": 1, "type": 1, "void_time": 1}&filter={"status":"Void"}`;
    } else if (isVoid) {
      url += `&addon={"void_remark":1,"void_by_id":1,"create_local_time": 1, "type": 1,"void_time": 1}&filter={"status":"Void"}`;
    } else if (!isVoid && type === "transactions" && fromDate === toDate) {
      url += `&addon={"create_local_time":1, "type": 1}&filter={"bill_detail":{"$ne":null},"create_local_time":{"$gte":"${moment(
        fromDate
      )
        //.subtract(1, "days")
        .format("YYYY-MM-DD 00:00:01")}","$lte":"${moment(fromDate).format(
        "YYYY-MM-DD 23:59:59"
      )}"}}`;
    } else if (!isVoid && type === "transactions") {
      url += `&addon={"create_local_time":1, "type": 1}&filter={"bill_detail":{"$ne":null},"create_local_time":{"$gte":"${moment(
        fromDate
      ).format("YYYY-MM-DD 00:00:01")}","$lte":"${moment(toDate).format(
        "YYYY-MM-DD 23:59:59"
      )}"}}`;
    }
    if (type === "products") {
      url += `&addon={"product_id":1}`;
    }

    if (type === "product-categories") {
      url += `&addon={"product_category_id":1}`;
    }

    if (type === "product-sub-categories") {
      url += `&addon={"product_sub_category_id":1}`;
    }
    if (filter) url += `&filter=${JSON.stringify(filter)}`;

    const result = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    return result;
  };

  const getBigspenderCondition = async () => {
    const { token } = settings();
    let url = `${process.env.REACT_APP_API_ENDPOINT}/member-badges`;
    const result = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (result.ok) {
      const jsonResult = await result.json();

      const bigSpenderValue = jsonResult.payload.badges.find(
        (j) => j.name === "Big Spender"
      ).conditions[0].value;
      return [bigSpenderValue, null];
    } else {
      return [null, "load error"];
    }
  };

  const getFrequentCondition = async () => {
    const { token } = settings();
    let url = `${process.env.REACT_APP_API_ENDPOINT}/member-badges`;
    const result = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (result.ok) {
      const jsonResult = await result.json();

      const bigSpenderValue = jsonResult.payload.badges.find(
        (j) => j.name === "Frequent Member"
      ).conditions[0].value;
      return [bigSpenderValue, null];
    } else {
      return [null, "load error"];
    }
  };

  const getTransactions = async ({ fromDate, toDate, filter = null }) => {
    const result = await _fetch({
      type: "transactions",
      fromDate,
      toDate,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      let datas;
      if (filter === "member") {
        datas = jsonResult.payload.transactions?.filter(
          (t) => t.guest === null && Object.keys(t.member).length !== 0
        );
      } else if (filter === "guest") {
        datas = jsonResult.payload.transactions?.filter(
          (t) => Object.keys(t.member).length === 0 //t.guest !== null && t.guest !== undefined
        );
      } else datas = jsonResult.payload.transactions;
      return [datas, null];
    } else {
      return [null, "error"];
    }
  };

  const getAllRevenue = async ({ fromDate, toDate, periodType }) => {
    const result = await _fetch({
      type: "total-revenue",
      fromDate,
      toDate,
      periodType,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.total_revenue, null];
    } else {
      return [null, "error"];
    }
  };

  const getMembers = async ({
    fromDate,
    toDate,
    periodType,
    filter = null,
    allBranch = false,
  }) => {
    const result = await _fetch({
      type: "members",
      fromDate,
      toDate,
      periodType,
      filter,
      allBranch,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.members, null];
    } else {
      return [null, "error"];
    }
  };

  const getGuests = async ({ fromDate, toDate, periodType }) => {
    const result = await _fetch({
      type: "guests",
      fromDate,
      toDate,
      periodType,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.guests, null];
    } else {
      return [null, "error"];
    }
  };

  const getTotalTransactions = async ({ fromDate, toDate, periodType }) => {
    const result = await _fetch({
      type: "total-trans",
      fromDate,
      toDate,
      periodType,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.total_trans, null];
    } else {
      return [null, "error"];
    }
  };

  const getVoidTransactions = async ({ fromDate, toDate, periodType }) => {
    const result = await _fetch({
      type: "transactions",
      // type: "total-trans-void",
      fromDate,
      toDate,
      periodType,
      isVoid: true,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      const filterdTransactions =
        periodType !== "All"
          ? jsonResult.payload.transactions?.filter((t) => {
              if (fromDate === toDate) {
                console.log(moment(t.void_time).format("YYYY-MM-DD"));

                return moment(moment(t.void_time).format("YYYY-MM-DD")).isSame(
                  moment(fromDate)
                );
              } else
                return moment(t.void_time).isBetween(
                  moment(fromDate),
                  moment(toDate)
                );
            })
          : jsonResult.payload.transactions;
      return [filterdTransactions, null];
    } else {
      return [null, "error"];
    }
  };

  const getTotalPoints = async ({ fromDate, toDate, periodType }) => {};

  const getTotalEarn = async ({ fromDate, toDate, periodType }) => {
    const result = await _fetch({
      type: "total-earn",
      fromDate,
      toDate,
      periodType,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.total_earn, null];
    } else {
      return [null, "error"];
    }
  };

  const getTotalRedeem = async ({ fromDate, toDate, periodType }) => {
    const result = await _fetch({
      type: "total-redeem",
      fromDate,
      toDate,
      periodType,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.total_redeem, null];
    } else {
      return [null, "error"];
    }
  };

  const getProducts = async ({
    fromDate,
    toDate,
    periodType,
    filter = null,
  }) => {
    const result = await _fetch({
      type: "products",
      fromDate,
      toDate,
      periodType,
      filter,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.products, null];
    } else {
      return [null, "error"];
    }
  };

  const getProductsQTY = async ({ fromDate, toDate, periodType }) => {
    const result = await _fetch({
      type: "total-qty",
      fromDate,
      toDate,
      periodType,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.total_qty, null];
    } else {
      return [null, "error"];
    }
  };

  const getCategory = async ({ fromDate, toDate, periodType }) => {
    const result = await _fetch({
      type: "product-categories",
      fromDate,
      toDate,
      periodType,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.product_categories, null];
    } else {
      return [null, "error"];
    }
  };

  const getSubcategory = async ({ fromDate, toDate, periodType }) => {
    const result = await _fetch({
      type: "product-sub-categories",
      fromDate,
      toDate,
      periodType,
    });
    if (result.ok) {
      const jsonResult = await result.json();
      return [jsonResult.payload.product_sub_categories, null];
    } else {
      return [null, "error"];
    }
  };

  const getProductDatas = async ({ categoryId, subcategoryId }) => {
    const { token } = settings();
    let url = `${process.env.REACT_APP_API_ENDPOINT}/products`;
    if (subcategoryId || categoryId) {
      url += "?filter=";
      if (subcategoryId) url += `{"sub_category_id":"${subcategoryId}"}`;
      else if (categoryId) url += `{"category_id":"${categoryId}"}`;
    }
    const result = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (result.ok) {
      const jsonResult = await result.json();

      return [jsonResult.payload.products, null];
    } else {
      return [null, "load error"];
    }
  };
  const getTiers = async () => {
    const { token } = settings();
    let url = `${process.env.REACT_APP_API_ENDPOINT}/member-tiers`;
    const result = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (result.ok) {
      const jsonResult = await result.json();

      return [jsonResult.payload.tiers, null];
    } else {
      return [null, "load error"];
    }
  };

  const getBigSpenders = async ({ toDate }) => {
    const { branchId, token } = settings();
    let url = `${
      process.env.REACT_APP_API_ENDPOINT
    }/stat/big-spenders?period_type=Day&from=2020-01-01&to=${toDate}${
      branchId ? `&branch_id=${branchId}` : ""
    }&projection={"phone":1,"time":1}`;
    const result = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });

    if (result.ok) {
      const jsonResult = await result.json();

      return [jsonResult.payload.big_spenders, null];
    } else {
      return [null, "error"];
    }
  };

  const getFrequentMembers = async ({ toDate }) => {
    const { branchId, token } = settings();
    let url = `${
      process.env.REACT_APP_API_ENDPOINT
    }/stat/frequent-members?period_type=Day&from=2020-01-01&to=${toDate}${
      branchId ? `&branch_id=${branchId}` : ""
    }&projection={"phone":1,"time":1}`;
    const result = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });

    if (result.ok) {
      const jsonResult = await result.json();

      return [jsonResult.payload.frequent_members, null];
    } else {
      return [null, "error"];
    }
  };

  return {
    getAllRevenue,
    getTransactions,
    getMembers,
    getGuests,
    getTotalTransactions,
    getVoidTransactions,
    getTotalPoints,
    getTotalEarn,
    getTotalRedeem,
    getProducts,
    getProductsQTY,
    getSubcategory,
    getCategory,
    getBigspenderCondition,
    getFrequentCondition,
    getTiers,
    getProductDatas,
    getBigSpenders,
    getFrequentMembers,
  };
};

export default useAllStat;
